import { render, staticRenderFns } from "./RacingMaze.vue?vue&type=template&id=1e47539e&"
import script from "./RacingMaze.vue?vue&type=script&lang=js&"
export * from "./RacingMaze.vue?vue&type=script&lang=js&"
import style0 from "./RacingMaze.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports